// node-modules
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd';
import _debounce from 'lodash/debounce';
import Hammer from 'hammerjs';

// constants
import { DOCUMENT_ELEMENT, KEY_CODES, SELECTORS } from '@/scripts/constants';

// other
import { toggleModal, transitionend, isMobile } from '@/scripts/utils';
import { swiperSliderAdvanced } from '@/components';

// assets
import './GalleryModal.scss';


const defaults = {
  triggerElements: '[data-role*="gallery-modal-trigger"]',
  modalElement: '[data-role*="gallery-modal-element"]',
  modalTop: '[data-role*="modal-top"]',
  modalBot: '[data-role*="modal-bot"]',
  modalMain: '[data-role*="modal-main"]',
  modalClose: '[data-role*="modal-close"]',
  activeClass: SELECTORS.gallery_modal_opened,
  loadingClass: SELECTORS.loading,
};

export default class GalleryModal {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.triggerElements = options.triggerElements;

    this.$modal = $(options.modalElement);
    this.$modalSlidesContainer = this.$modal.find('[data-role="slides-container"]');
    this.$top = this.$modal.find(options.modalTop);
    this.$main = this.$modal.find(options.modalMain);
    this.$bot = this.$modal.find(options.modalBot);
    this.$close = this.$modal.find(options.modalClose);
    this.slider = null;

    this.activeClass = options.activeClass;
    this.loadingClass = options.loadingClass;
    this.init();
  }

  toggleStatus(flag) {
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass, flag);
    return toggleModal(flag, null, this.$modal[0]);
  }

  get activeStatus() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  initModal(el) {
    const { params, title } = el.dataset;
    const { type, url, data } = JSON.parse(params);
    this.$modal.addClass(this.loadingClass);
    $.ajax({
      type,
      url,
      data,
      success: (result) => {
        this.$modalSlidesContainer.append(result);
        [this.slider] = swiperSliderAdvanced({
          swiperTitle: title,
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 1000,
          pagination: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          selector: 'modal-gallery',
        });
        this.resize();
        imagesLoaded(this.$modal[0], () => {
          this.resize();
          this.$modal.removeClass(this.loadingClass);
        });
      },
    });
    return this.toggleStatus(true);
  }

  destroyModal() {
    transitionend(this.$modal[0], 'transitionend', () => {
      this.slider.destroy();
      this.$modalSlidesContainer.children().remove();
    });
    return this.toggleStatus(false);
  }

  resize() {
    this.$main.css({
      height: window.innerHeight - this.$top.height() - this.$bot.height(),
    });
  }

  initKeyboardNav() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_CODES.esc && this.activeStatus) {
        this.destroyModal();
      }
    });
  }

  initMobileNav() {
    const hammer = new Hammer(this.$modal[0]);
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
    hammer.on('swipeup', () => {
      if (this.activeStatus) this.destroyModal();
    });
  }

  init() {
    const self = this;
    this.initKeyboardNav();
    if (isMobile()) {
      this.initMobileNav();
    }
    $(document).on('click', this.triggerElements, function click(e) {
      e.preventDefault();
      self.initModal(this);
    });
    this.$close.on('click', () => {
      this.destroyModal();
    });
    this.resize();
    window.addEventListener('resize', _debounce(() => this.resize(), 100));
  }
}



// WEBPACK FOOTER //
// ./components/GalleryModal/GalleryModal.js